/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function DocumentClassActionsRepresentationFromJSON(json) {
    return DocumentClassActionsRepresentationFromJSONTyped(json, false);
}
export function DocumentClassActionsRepresentationFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        canCreate: json['canCreate'],
        canDeleteById: json['canDeleteById'],
        canDuplicate: json['canDuplicate'],
        canFindAll: json['canFindAll'],
        canGetById: json['canGetById'],
        canUpdate: json['canUpdate'],
    };
}
export function DocumentClassActionsRepresentationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        canCreate: value.canCreate,
        canDeleteById: value.canDeleteById,
        canDuplicate: value.canDuplicate,
        canFindAll: value.canFindAll,
        canGetById: value.canGetById,
        canUpdate: value.canUpdate,
    };
}
